import './index.scss'
import { __ } from '@wordpress/i18n';
import classnames from 'classnames';

import  ResetAttributes  from '../../../general/ResetButton.js'

import { createHigherOrderComponent } from '@wordpress/compose';

import { useState, useEffect } from '@wordpress/element';
import { addFilter } from '@wordpress/hooks';
import { useSelect } from '@wordpress/data';

import { InspectorControls } from '@wordpress/block-editor';
import {	
	SelectControl,
	Button,
	RangeControl,
	TextControl,
	ToggleControl,
	Flex, 
	FlexItem,
	ButtonGroup,
	PanelBody
} from '@wordpress/components';


//const allowedBlocks = [ 'core/group', 'core/post-template' ];
const allowedBlocks = [ 'core/group' ];
const agridDefaults = {
	aOn: false,
	gridList: ['', '', 2, 1], // [lg, md, sm, ssm]	
}

const addAttributes = ( settings, name ) => {		

	if (!allowedBlocks.includes(name)) return settings;	

	if( typeof settings.attributes !== 'undefined' ){	
		settings.attributes = {
      ...settings.attributes,		
			agrid: {
				type: 'object',
				default: agridDefaults,
			}		
		}   
	}
	return settings;
}


const addInspectorControl = createHigherOrderComponent( ( BlockEdit ) => {
	return (props) => {

		if (!allowedBlocks.includes(props.name)) return <BlockEdit {...props} />;

		const {	attributes, setAttributes, isSelected	} = props;
		const { agrid = {} } = attributes;

	  const orgDefaults = {
			...agridDefaults,
			...(attributes.agrid || {}),
		}

		const { 
			aOn, 
			gridList
		} = orgDefaults;

		const isDifferentFromDefault = JSON.stringify({ ...agrid, aOn: undefined }) !== JSON.stringify({ ...agridDefaults, aOn: undefined });

    const isGridGroup = props.name === "core/group" && attributes.layout?.type === "grid";
		const isnotColumn = isGridGroup && attributes.layout.columnCount;

		

		const updateObject = (obj, key, newVal) => ({ ...obj, [key]: newVal });
	const updateArray =( list, index, newval ) =>{		
		const listsCopy = [ ...list ];					
		listsCopy[ index ] = newval;		
		return listsCopy;			
	}


	const reset = () => {
		setAttributes({ 
			agrid: { 
				...agrid, 
				gridList: ['', '', '', ''] 
			} 
		});		
	}
		
	  const [syncViewport, setSyncViewport] = useState(false);
		const [breakPoint, setBreakPoint] = useState(0);
	
		useEffect(() => {
			const update = () => {
				let temp = 'Desktop';
				if (breakPoint === 1) temp = 'Tablet';
				if (breakPoint === 2) temp = 'Mobile';
				if (breakPoint === 3) temp = 'Mobile'; // SSmall Screen
				if (syncViewport) wp.data.dispatch('core/editor').setDeviceType(temp);
			};
			update();
		}, [syncViewport, breakPoint]);
		  
   
		return (
			<>
				<BlockEdit { ...props } />

				{ ( isnotColumn ) && (
					<InspectorControls group="settings">
						
            	<PanelBody title={__('Grid Setting', 'aver')} initialOpen={aOn}>			

				
					
								<Flex>
									<FlexItem>
										<ToggleControl
											label={__('Enable Grid', 'aver')}
											checked={aOn}
											onChange={(val) => setAttributes({ agrid: {...agrid, aOn: val }})}
										/>
									</FlexItem>
									<FlexItem>
										{ isDifferentFromDefault && (
											<ResetAttributes
												onConfirm={() => {
													setAttributes({
														agrid: agridDefaults
													});								
												}}
											/> 
										)}
									</FlexItem>
								</Flex>			

								{ aOn && <>
								
								<Flex style={{margin: '1rem 0'}}>
									<FlexItem className="button-frame">
										<Button icon="welcome-view-site" label="Sync Viewport" onClick={() => setSyncViewport(!syncViewport)}	isPressed={syncViewport} />
										<Button icon="undo"	label="Reset All"	onClick={()=> reset()}	/>
									</FlexItem>
									<FlexItem className="button-frame">
										<Button	icon="desktop" isPressed={breakPoint === 0}	onClick={() => setBreakPoint(0)} label=">1024px, <1440px" />
										<Button icon="tablet"	isPressed={breakPoint === 1} onClick={() => setBreakPoint(1)}	label="≥782px" />
										<Button	icon="smartphone"	isPressed={breakPoint === 2} onClick={() => setBreakPoint(2)}	label="<782px"/>
										<Button	icon="editor-contract"	isPressed={breakPoint === 3} onClick={() => setBreakPoint(3)}	label="<600px"/>
									</FlexItem>
								</Flex>					
							
									<RangeControl
										label={__(`gridList[${breakPoint}]`, 'aver')}
										onChange={(newval) =>
											setAttributes({ agrid: {...agrid, gridList: updateArray(gridList, breakPoint, newval)}})
										}									
										min={1}
										max={ ( breakPoint == 2 || breakPoint == 3 ) ? 2 : breakPoint == 0 ? 6 : 4 }									
										value={ gridList[breakPoint] }
										__nextHasNoMarginBottom={true}
									/>			
							</>}
				
					</PanelBody>
					</InspectorControls> )}
			</>
		);
	};
}, 'withInspectorControl');


const applyExtraClassEditor = createHigherOrderComponent( ( BlockListBlock ) => {
	return (props) => {

    if (!allowedBlocks.includes(props.name)) return <BlockListBlock {...props} />	

		const { attributes, wrapperProps, className } = props;
		const orgDefaults = {
			...agridDefaults,
			...(attributes.agrid || {}),
		}

		const { 
			aOn, 
			gridList
		} = orgDefaults;

		if (!aOn) {
			return <BlockListBlock {...props} />;
		}


		const cssstyle = { 
			...wrapperProps?.style,
		}		
		   
  	const breakpointClasses = ['lg', 'md', 'sm', 'ssm'];
	
		const responsiveClasses = gridList
			.map((val, index) => (val ? `col-${breakpointClasses[index]}-${val}` : null))
			.filter(Boolean); // removing any falsy values from the array
	
		const classes = classnames(className, ...responsiveClasses);
	
		return (
			<BlockListBlock
				{...props}
				wrapperProps={{ style: { ...wrapperProps?.style } }}
				className={classes}
			/>
		)
	}})
	
	


addFilter(
	'blocks.registerBlockType',
	'aver/aver-grid-attributes',
	addAttributes
);

addFilter(
	'editor.BlockEdit',
	'aver/aver-grid-advanced-control',
	addInspectorControl
);

addFilter(
	'editor.BlockListBlock',
	'aver/aver-grid-editor-class',
	applyExtraClassEditor,
);

